import React from "react";
import HeroSection from "./HeroSection";
import RegisterSection from "./RegisterSection";
import moment from "moment";

const HeroSectionGuest = ({ freeUntil }) => {
  const isFreePeriod = moment(freeUntil).isAfter(moment());
  
  return (
    <HeroSection
      title="PMIstandards+  Success at Your Fingertips"
      tagLine="Try this new digital solution for instant access to the PMI standards, guides, how-to content and more—all tailored to industry, approach and goals."
      tagLineTwo=""
    >
      <RegisterSection />
    </HeroSection>
  );
};

export default HeroSectionGuest;
